import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { showAlert } from "../../../../actions/App/action";
import { toggleWatchLoad } from "../../../utils/watchedUtil";
import {
  getApiErrorMessage,
  getResultIdMessage,
  getRecommendedApiError,
  getRecommendedFilter,
  getRecommendedMessage,
  getTotalRecommendedRecords,
  getTotalWatchedRecords,
  getWatchedFilter,
  makeSelectRecommended,
  makeSelectRecommendedLoaded,
  makeSelectWatched,
  makeSelectWatchedLoaded,
} from "../../../../selectors/Home/selector";
import {
  addWatchLoad,
  removeRecommendedResults,
  removeWatchLoad,
  removeWatchLoadSuccess,
  watchedLoadsRequest,
} from "../../../../actions/Home/action";
import {
  getNetworkStatus,
  getUserMasterData
} from "../../../../selectors/selector";
import useInjectSaga from "../../../../utils/injectSaga";
import useInjectReducer from "../../../../utils/injectReducer";
import reducer from "../../../../reducers/myload/reducer";
import {
  buyLoadRequest,
  buyLoadShipmentRequest,
  buyLoadStatusRemove,
} from "../../../../actions/BookLoad/action";
import {
  getBookLoadStatus,
  getCarrierAssignedLoads,
  getLoadData,
  getShipmentDetails,
} from "../../../../selectors/Myload/selector";
import {
  getDeepLinkURI,
  getRefreshStatus,
} from "../../../../selectors/selector";
import * as Constants from "../../../../utils/constants";
import { getFormatRoles } from "../../../../utils/formatData";
import { compose } from "redux";
import homeSaga from "../../../../saga/Home/saga";
import { getWatchedLoads } from "../../../../utils/HomeUtils/Home";
import { TopRecommendationsProps } from "./types";
import { removeSearchResults } from "../../../../actions/Search/action";
import TopRecommendation from './TopRecommendation/TopRecommendation'
import { getPredecessorShipment } from "../../../../actions/carrierAssign/action";
const TopRecommendations = (props: TopRecommendationsProps) => {
  const { loadDetails, userDetails, getWatchedLoadsData, isTopRecomm } = props;
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [sortColumn, setSortColumn] = useState<string>(
    Constants.pickUpStartDate
  );
  const [sortDirection, setSortDirection] = useState<string>(
    Constants.SORTING_ORDER_ASC
  );
  const [isWatchLoadEnd, setWatchedLoadEnd] = useState(false);
  const roles = getFormatRoles();
  const setPaginationValues = (page = 0, status = false) => {
    setCurrentPage(page);
    setWatchedLoadEnd(status);
  };
  useEffect(() => {
    getWatchedLoads(
      userDetails,
      props.watchedData,
      setPaginationValues,
      true,
      currentPage,
      false,
      sortColumn,
      sortDirection,
      roles
    );
  }, [isTopRecomm]);
  const toggleWatchClick = (load: any) => {
    let status = false;
    getWatchedLoadsData.length > 0 &&
      getWatchedLoadsData.forEach((watchLoad: any) => {
        if (watchLoad.loadId === load.loadId) {
          status = true;
          return;
        }
      });
    toggleWatchLoad(props)(load.loadId, load, status);
  };
  return isTopRecomm ? (
    <div
      className="sni-matched-wrapper sni-results-wrappers"
      style={{ marginBottom: "40px" }}
    >
      <div className="top-recomm-title">Top Recommendations</div>
      <div className="top-recomm-tiles-container">
        {loadDetails.map((loads: any, index: number) => (
          <TopRecommendation
            refreshTopRecommendData={() => props.refreshTopRecommend()}
            onWatchIconClick={(load: any) => toggleWatchClick(load)}
            {...props}
            {...loads}
            load={loads}
            key={`top_recommendation_${index}`}
          />
        ))}
      </div>
    </div>
  ):null;
};

const mapStateToProps = createStructuredSelector({
  deepLinkURI: getDeepLinkURI(),
  getWatchedLoadsData: makeSelectWatched(),
  pullToRefreshStatus: getRefreshStatus(),
  filter: getWatchedFilter(),
  recommendedfilter: getRecommendedFilter(),
  apiError: getApiErrorMessage(),
  resultId: getResultIdMessage(),
  getRecommendedLoadsData: makeSelectRecommended(),
  isRecommendedLoaded: makeSelectRecommendedLoaded(),
  isWatchedLoaded: makeSelectWatchedLoaded(),
  totalWatchedRecords: getTotalWatchedRecords(),
  totalRecommendedRecords: getTotalRecommendedRecords(),
  isNetworkAvailable: getNetworkStatus(),
  userDetails: getUserMasterData(),
  bookLoadStatus: getBookLoadStatus(),
  getShipmentDetails: getShipmentDetails(),
  carrierLoads: getCarrierAssignedLoads(),
  noRecommendationMessage: getRecommendedMessage(),
  getRecommendedApiError: getRecommendedApiError(),
  loadData: getLoadData(),
});
export const mapDispatchToProps = (dispatch: Function) => ({
  watchedData: (data: any) => dispatch(watchedLoadsRequest(data)),
  showAlert: (data: any) => dispatch(showAlert(data)),
  addWatchLoad: (payload: any) => dispatch(addWatchLoad(payload)),
  removeWatchLoad: (payload: any) => dispatch(removeWatchLoad(payload)),
  buyLoadRequest: (payload: any) => dispatch(buyLoadRequest(payload)),
  buyLoadStatusRemove: () => dispatch(buyLoadStatusRemove()),
  buyLoadShipmentRequest: (payload: any, renderCallback: Function) =>
    dispatch(buyLoadShipmentRequest(payload, renderCallback)),
  removeRecommendedResults: (data: any) =>
    dispatch(removeRecommendedResults(data)),
  removewatchedResults: (payload: any) =>
    dispatch(removeWatchLoadSuccess(payload)),
  removeSearchResults: (data: any) => dispatch(removeSearchResults(data)),
  getPredecessorShipment :(details: any, callBack: any) => dispatch(getPredecessorShipment(details,callBack))
});

const key = "myload";
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });

const withSaga = useInjectSaga({ key: "carrier", saga: homeSaga });

export default compose<any>(
  withSaga,
  withConnect,
  withReducer
)(TopRecommendations);